package com.nonopn.skydome.common.app.navigation

import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect

import com.nonopn.icons.Logout
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.account.AccountScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.title_account
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem

import kotlinx.serialization.Serializable

import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters

@Serializable
object RouteSettings : RouteParameterTo

object RouterSettings : RouterNoParameters<RouteSettings>(RouteSettings::class) {
    override fun routeFrom(parameters: RouteSettings) = "/settings"

    @Composable
    override fun Show(parameters: RouteSettings) {
        RouteSettingsImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteSettings,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(launchSingleTop = true)
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteSettings

    override fun isMatching(route: String) = route == "/settings"

    override fun navigateFrom(path: String) = RouteSettings
}

class RouteSettingsImpl : Route<RouteSettings>(
    route = "/settings",
    params = RouteSettings,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current

        LaunchedEffect(Unit) {
            appModel.setAppBarState(
                AppBarState.Localized(
                    title = Res.string.title_account,
                    listOf(
                        MenuItem.MenuItemSimple(
                            imageVector = Icons.Rounded.Logout,
                            onClick = { appModel.logout() }
                        )
                    )
                )
            )
        }

        AccountScreen()
    }
}
